import { Box } from "@mui/system";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import {
  allFilters,
  filterHeaderSearchOrganization,
} from "../../redux/actions/filterActions";
import { filterHeaderOrganization } from "../../redux/store/storeConstants";
import { filterKeys } from "../../utils/constants/filters";
import { leadsEndpoints } from "../../utils/constants/httpConstants";
import { CustomAutoComplete } from "../Autocomplete";
import { styles } from "./styles";
import Checkbox from "../Buttons/Checkbox/Checkbox";
import { STRINGS } from "./strings";

const FilterTypeOrganization = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const allFiltersSelector = useSelector(
    (state) => state?.allFilters?.payload
  ) || {
    exist_fields: [],
    not_exist_fields: [],
  };

  const selectedOrganizationFilter = useSelector(
    (state) => state.filterHeaderOrganization?.payload
  ) || {
    anyOf: false,
    notAnyOf: false,
    isKnown: false,
    isUnknown: false,
  };

  const handleOrganizationChange = (item, filter) => {
    let payload = {
      ...selectedOrganizationFilter,
      [item]: !selectedOrganizationFilter[item],
      isKnown: false,
      isUnknown: false,
    };

    const unCheckPayload = {};
    if (!payload.anyOf) unCheckPayload[filter] = [];
    if (!payload.notAnyOf) unCheckPayload[filter + "_not"] = [];

    dispatch(
      allFilters({
        ...unCheckPayload,
        exist_fields: allFiltersSelector.exist_fields.filter(
          (e) => e !== filter
        ),
        not_exist_fields: allFiltersSelector.not_exist_fields.filter(
          (e) => e !== filter
        ),
      })
    );

    navigate({
      pathname: location.pathname,
      search: createSearchParams({
        ...allFiltersSelector,
        ...unCheckPayload,
        exist_fields: allFiltersSelector.exist_fields.filter(
          (e) => e !== filter
        ),
        not_exist_fields: allFiltersSelector.not_exist_fields.filter(
          (e) => e !== filter
        ),
      }).toString(),
    });

    dispatch(filterHeaderSearchOrganization(payload));
  };

  const handleExistFields = (
    existing_type,
    filter,
    queryInsertKey,
    notFilterKey
  ) => {
    let payload = {
      ...selectedOrganizationFilter,
      [existing_type]: !selectedOrganizationFilter[existing_type],
    };

    dispatch(filterHeaderSearchOrganization(payload));

    if (payload[existing_type]) {
      const queryPayload = {
        [queryInsertKey]: [...allFiltersSelector[queryInsertKey], filter],
        [notFilterKey]: allFiltersSelector[notFilterKey].filter(
          (e) => e !== filter
        ),
        [filter]: [],
        [filter + "_not"]: [],
      };
      dispatch(allFilters(queryPayload));
      navigate({
        pathname: location.pathname,
        search: createSearchParams({
          ...allFiltersSelector,
          ...queryPayload,
        }).toString(),
      });
    } else {
      const queryPayload = {
        [queryInsertKey]: allFiltersSelector[queryInsertKey].filter(
          (e) => e !== filter
        ),
      };
      dispatch(allFilters(queryPayload));
      navigate({
        pathname: location.pathname,
        search: createSearchParams({
          ...allFiltersSelector,
          ...queryPayload,
        }).toString(),
      });
    }
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.filterContainer}>
        <div style={styles.jobTitleHead}>
          <Checkbox
            checked={!!selectedOrganizationFilter.anyOf}
            onClick={() =>
              handleOrganizationChange("anyOf", filterKeys.organization)
            }
            label={STRINGS.IS_ANY_OF}
          />
        </div>
        {selectedOrganizationFilter.anyOf && (
          <Box>
            <CustomAutoComplete
              filter={filterKeys.organization}
              type=""
              endPoint={leadsEndpoints.getOrganizationFilters}
            />
          </Box>
        )}

        <div style={styles.jobTitleHead}>
          <Checkbox
            checked={!!selectedOrganizationFilter.notAnyOf}
            onClick={() =>
              handleOrganizationChange("notAnyOf", filterKeys.organization)
            }
            label={STRINGS.IS_NOT_ANY_OF}
          />
        </div>
        {selectedOrganizationFilter.notAnyOf && (
          <Box>
            <CustomAutoComplete
              filter={filterKeys.organization}
              type="_not"
              endPoint={leadsEndpoints.getOrganizationFilters}
            />
          </Box>
        )}

        {/* <div style={styles.jobTitleHead}>
          <Checkbox
            checked={!!selectedOrganizationFilter.isKnown}
            onClick={() =>
              handleExistFields(
                'isKnown',
                filterKeys.organization,
                'exist_fields',
                'not_exist_fields'
              )
            }
            label={STRINGS.IS_KNOWN}
          />
        </div> */}

        {/* <div style={styles.jobTitleHead}>
          <Checkbox
            checked={!!selectedOrganizationFilter.isUnknown}
            onClick={() =>
              handleExistFields(
                'isUnknown',
                filterKeys.organization,
                'not_exist_fields',
                'exist_fields'
              )
            }
            label={STRINGS.IS_UNKNOWN}
          />
        </div> */}
      </Box>
    </Box>
  );
};

export default FilterTypeOrganization;
